package navigation.settings

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase

class SettingsScreenModel(
    getCurrentUserUseCase: GetCurrentUserUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<SettingsState>(SettingsState()) {

    private val settingsViewModel =
        SettingsViewModel(
            getCurrentUserUseCase = getCurrentUserUseCase,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )
}